















import { DynamicDocumentItem, DynamicDocumentItemData, InstallationModuleData } from '@/types';

import Vue, { PropType } from 'vue';

import SolarGrid from '@/components/SolarGrid';

export default Vue.extend({
  components: {
    SolarGrid,
  },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    data: Object as PropType<DynamicDocumentItemData>,
  },
});
